import PropTypes from 'prop-types';

export const EventConfigPropTypes = PropTypes.shape({
	name:                        PropTypes.string.isRequired,
	className:                   PropTypes.string.isRequired,
	start:                       PropTypes.string.isRequired,
	end:                         PropTypes.string.isRequired,
	redirect:                    PropTypes.string,
	hidesDailyBonusPage:         PropTypes.bool.isRequired,
	actorName:                   PropTypes.string,
	headerBg:                    PropTypes.string,
	headerTitle:                 PropTypes.string,
	headerDescription:           PropTypes.string,
	interactiveBg:               PropTypes.string,
	historyBg:                   PropTypes.string,
	homepageBlockBg:             PropTypes.string,
	showMysteriousTomorrowOffer: PropTypes.bool.isRequired,
	headerBgLogo:                PropTypes.string,
});
